<template>
    <select class="form-control form-control-sm" @change="e => changeLanguage(e.target.value)">
        <option v-for="language in languages"
                :value="language"
                v-text="__('languages.with_flag.' + language)"
                :selected="language === $locale"/>
    </select>
</template>

<script>
export default {
    data() {
        return {
            languages: ['en', 'de', 'fr'],
        };
    },

    methods: {
        changeLanguage(targetLanguage) {
            window.location = this.$route('user.localization', {language: targetLanguage});
        },
    },
};
</script>